import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import axios from 'axios';
import { Constants } from '../../endPoints'; // ✅ Import API Constants
import { jwtDecode } from 'jwt-decode';

export default function DashboardNav() {
    const history = useHistory();
    const [unreadCount, setUnreadCount] = useState(0);

    const handleLogout = () => {
        // Clear authentication tokens from local storage
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');

        // Redirect to login page
        history.push('/login');
    };

    useEffect(() => {
        fetchUnreadMessages();
        const interval = setInterval(fetchUnreadMessages, 60000); // Every 60 seconds refresh

        return () => clearInterval(interval); // Clear interval on unmount
    }, []);

    const fetchUnreadMessages = async () => {
        try {
            const token = localStorage.getItem('authToken');
            if (!token) return;
            const decoded = jwtDecode(token);
    
            const response = await axios.post(`${Constants.getChatListForProductOwner}`, { user_id: decoded.id });
    
            if (response.data.status === 1) {
                const unreadChats = response.data.list.filter(chat => chat.unread_count > 0);  // ✅ list instead of data
                const totalUnread = unreadChats.reduce((sum, chat) => sum + chat.unread_count, 0);
                setUnreadCount(totalUnread);
            }
        } catch (error) {
            console.error('Error fetching unread messages:', error);
        }
    };
    

    return (
        <div className='bg-[#fbf8f1] border-2 border-[#b3902d] rounded-lg overflow-hidden py-2'>
            <Link to="/dashboard" className="block py-3 px-6 border-b border-[#e6e0d3] hover:bg-[#fff] transition-all">
                <div className='flex gap-3 items-center'>
                    <i class="fa-regular fa-home text-[#b3902d]"></i> Dashboard
                </div>
            </Link>
            <Link to="/profile" className="block py-3 px-6 border-b border-[#e6e0d3] hover:bg-[#fff] transition-all">
                <div className='flex gap-3 items-center'>
                    <i class="fa-regular fa-user text-[#b3902d]"></i> Profile
                </div>
            </Link>
            <Link to="/list-wishlist" className="block py-3 px-6 border-b border-[#e6e0d3] hover:bg-[#fff] transition-all">
                <div className='flex gap-3 items-center'>
                    <i class="fa-regular fa-heart text-[#b3902d]"></i> Saved
                </div>
            </Link>
            <Link to="/sell-product" className="block py-3 px-6 border-b border-[#e6e0d3] hover:bg-[#fff] transition-all">
                <div className='flex gap-3 items-center'>
                    <i class="fa-regular fa-suitcase text-[#b3902d]"></i> Sell Product
                </div>
            </Link>
            <Link to="/list-product" className="block py-3 px-6 border-b border-[#e6e0d3] hover:bg-[#fff] transition-all">
                <div className='flex gap-3 items-center'>
                    <i class="fa-sharp fa-regular fa-rings-wedding text-[#b3902d]"></i>  Listing
                </div>
            </Link>
            <Link to="/inbox" className="block py-3 px-6 border-b border-[#e6e0d3] hover:bg-[#fff] transition-all relative">
                <div className='flex gap-3 items-center'>
                    <i className="fa-regular fa-envelope text-[#b3902d]"></i>Chat Inbox {unreadCount > 0 && (
                        <span className="ml-2 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-white bg-red-600 rounded-full">
                            {unreadCount}
                        </span>
                    )}
                </div>
            </Link>
            {/* <Link to="" className="block py-3 px-6 border-b border-[#e6e0d3] hover:bg-[#fff] transition-all">
            <div className='flex gap-3 items-center'>
                <i class="fa-regular fa-bell text-[#b3902d]"></i> Notifications
            </div>
        </Link> */}
            <Link to="/changed-password" className="block py-3 px-6 border-b border-[#e6e0d3] hover:bg-[#fff] transition-all">
                <div className='flex gap-3 items-center'>
                    <i class="fa-regular fa-lock text-[#b3902d]"></i> Change Password
                </div>
            </Link>
            <Link to="" onClick={handleLogout} className="block py-3 px-6 hover:bg-[#fff] transition-all">
                <div className='flex gap-3 items-center'>
                    <i class="fa-solid fa-power-off text-[#b3902d]"></i> Logout
                </div>
            </Link>
        </div>
    )
}
